const initSeoContent = (): void => {
  const mobileWraps = document.querySelectorAll('.seo-content-wrap');

  Array.prototype.forEach.call(mobileWraps, (container: HTMLElement) => {
    const button = container.querySelector<HTMLElement>('.seo-content-button');

    button?.addEventListener('click', () => {
      const content = container.querySelector<HTMLElement>('.seo-content-inner');
      const children = content?.children[0] as HTMLElement | undefined;

      if (content && children) {
        content.style.height = `${children.clientHeight}px`;

        setTimeout(() => {
          content.style.height = 'auto';
          if (button) {
            button.style.display = 'none';
          }
          container.classList.add('opened');
        }, 1000);
      }
    });
  });
};

export default initSeoContent;
